module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-avatar-01-1621c441b1d83af1a06095a5a0cd6c24.png";